import Quiz from "../assets/Quiz.jpg"
import SweetMemories from "../assets/SweetMemories.webp"
import MyPortfolio from "../assets/MyPortfolio.webp"


export const projectList = [
    {
        name : "Quiz Corner",
        image : Quiz,
        skills : "JavaScript, ExpressJS, NodeJS, MongoDB, HTML, CSS "
    },
    {
        name : "Blog Project",
        image : SweetMemories,
        skills : "JavaScript, ReactJS, ExpressJS, NodeJS, MongoDB, JSX, CSS "
    },
    {
        name : "MyPortfolio Website",
        image : MyPortfolio,
        skills : "JavaScript, ReactJS, HTML, CSS "
    }
] 